import ContainerXL from 'Nori/Container/ContainerXL';
import Link from 'next/link';
import Image from 'Nori/Image';
import styles from './DesktopMenu.module.scss';
import NavigationLinks from './NavigationLinks';
import Button from 'Nori/Button';
import ExternalLink from 'Images/brand-icons/alt-external-link.svg';
import { useAppContext } from 'Providers/App';
import { ARIA, HEADER_CONTENT } from 'Custom/Header/es/Header.utils';
import { UI_ELEMENTS } from 'Providers/App/elements';
import { Links } from 'Custom/Header/es/Header.utils';
import BRAND_LOGO from 'Images/logos/main-logo.png';

const { modalHealthcare: modalHealthcareId, modalISI: modalISIId } =
  UI_ELEMENTS;

const AltDesktopMenu = ({ basic = false }) => {
  const { getElementClickHandler, getElementState } = useAppContext();

  const modalISIHandler = getElementClickHandler(modalISIId);
  const modalHealthcareHandler = getElementClickHandler(modalHealthcareId);
  const [modalISI, modalHealthcare] = getElementState(
    modalISIId,
    modalHealthcareId
  );

  return (
    <div className={`${styles.wrapper} ${styles.alt}`} data-qa-tag="desktop-menu-wrapper">
      <div className={styles.flexContainer} data-qa-tag="desktop-menu-flex-container">
        <div className={styles.logoContainer} data-qa-tag="desktop-menu-logo-container"></div>
        <div className={styles.navContainer} data-qa-tag="desktop-menu-nav-container">
          <div
            className={basic ? styles.topContainerWhite : styles.topContainer}
            data-qa-tag="desktop-menu-top-container"
          />
        </div>
      </div>
      <div className={styles.wrapperContainer} data-qa-tag="desktop-menu-wrapper-container">
        <ContainerXL data-qa-tag="desktop-menu-container-xl">
          <nav className={styles.mainNav} data-qa-tag="desktop-menu-main-nav">
            <div className={styles.logoWrapper} data-qa-tag="desktop-menu-logo-wrapper">
              <Link
                href={HEADER_CONTENT.mainRoute}
                className={styles.nexplanonLogo}
                data-qa-tag="desktop-menu-logo-link"
              >
                <Image
                  src={BRAND_LOGO}
                  width={BRAND_LOGO.width}
                  height={BRAND_LOGO.height}
                  layout="intrinsic"
                  alt={ARIA.logo}
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Logo"
                  data-design-label="Logotipo de Nexplanon"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  data-qa-tag="desktop-menu-logo-image"
                />
              </Link>
            </div>
            <div className={styles.mainNavContainer} data-qa-tag="desktop-menu-main-nav-container">
              <div className={styles.topNavigation} data-qa-tag="desktop-menu-top-navigation">
                <button
                  className={styles.link}
                  onClick={modalISIHandler}
                  data-design-category="top_nav_vd"
                  data-design-type="clickAction"
                  data-design-action="Expand"
                  data-design-label="Información de Seguridad Importante"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  aria-expanded={modalISI}
                  data-qa-tag="desktop-menu-modal-isi-button"
                >
                  <span className={styles.textBlock} data-qa-tag="desktop-menu-modal-isi-text">Información de</span>{' '}
                  Seguridad Importante
                </button>

                <Link
                  href="/static/pdf/PI-Spanish.pdf"
                  target="_blank"
                  rel="noopener"
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Download"
                  data-design-label="Información de Prescripción"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  data-qa-tag="desktop-menu-prescription-link"
                >
                  <span className={styles.textBlock} data-qa-tag="desktop-menu-prescription-text">Información de</span>{' '}
                  Prescripción
                </Link>
                <Link
                  href="/static/pdf/PPI-Spanish.pdf"
                  target="_blank"
                  rel="noopener"
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Download"
                  data-design-label="Información para el Paciente"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  data-qa-tag="desktop-menu-patient-info-link"
                >
                  <span className={styles.textBlock} data-qa-tag="desktop-menu-patient-info-text">Información para</span> el
                  Paciente
                </Link>
                <button
                  className={styles.link}
                  onClick={modalHealthcareHandler}
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Expand"
                  data-design-label="Profesionales de la Salud"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  aria-expanded={modalHealthcare}
                  data-qa-tag="desktop-menu-healthcare-button"
                >
                  <span className={styles.textBlock} data-qa-tag="desktop-menu-healthcare-text">Profesionales de</span> la Salud
                </button>
                {/* <Link
                  href="/"
                  target="_blank"
                  rel="noopener"
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Link"
                  data-design-label="Inglés"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  data-qa-tag="desktop-menu-english-link"
                >
                  Inglés
                </Link> */}
              </div>
              <div className={styles.mainMenu} data-qa-tag="desktop-menu-main-menu">
                <NavigationLinks links={Links} alternative data-qa-tag="desktop-menu-navigation-links" />
                <Button
                  data-design-type="clickAction"
                  data-design-category="top_nav_vd"
                  data-design-action="Button"
                  data-design-label="Buscar un Doctor"
                  data-design-nori_id="Navigation"
                  data-design-module_name="Navigation"
                  data-design-module_no="00"
                  data-qa-tag="desktop-menu-find-doctor-button"
                  className={styles.ctaButton}
                  type="btnBlueWhite"
                  href="/what-is-nexplanon/#find-a-doctor"
                  target="_blank"
                  rel="noopener"
                >
                  Buscar un Doctor
                </Button>
              </div>
            </div>
          </nav>
        </ContainerXL>
      </div>
    </div>
  );
};

export default AltDesktopMenu;
